import { setSelectedSite, setShowAnyLocation, setZipCode } from 'src/features/coveoSlice';
import { showLoader } from 'src/features/loaderSlice';
import type { AppDispatch } from 'src/store/store';
import { store } from 'src/store/store';

/** Store Find Trials site lock in Redux before navigating (no siteId/siteName query params). */
export const beginFindTrialsSiteNavigation = (
  dispatch: AppDispatch,
  params: { siteId: string; siteName?: string }
): void => {
  const siteId = params.siteId?.trim();
  if (!siteId) {
    return;
  }

  dispatch(
    setSelectedSite({
      siteId,
      siteName: params.siteName?.trim() || '',
    })
  );

  const state = store.getState();
  const { showAnyLocation } = state.coveoResult;
  if (!showAnyLocation) {
    dispatch(setShowAnyLocation());
  }

  const { isAuthenticated } = state.authentication;
  const searchZipCode = state.locationSearch?.searchZipCode;
  if (!isAuthenticated && searchZipCode) {
    dispatch(setZipCode(searchZipCode));
  }

  dispatch(showLoader());
};
